module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_ded",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("For the Morrigan. I am grateful for your gifts and victories.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For Catrina, Sonja, and Terry, for being my comrades in our many adventures. Even when I accidently forget I have volunteered us for rituals. Or when I accidently lock us all out of hotel rooms, cars, and other various places.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For all those who have helped me make the Morrigan’s Call a reality these many years. It has been an honor weaving magic together with you. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f55c04d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ded.vue
// module id = 66
// module chunks = 0